import { Link } from "react-router-dom";
import { Fish } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-border bg-background mt-16" data-testid="site-footer">
    <div className="patriot-band" aria-hidden />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid grid-cols-1 md:grid-cols-4 gap-8">
      <div className="md:col-span-1">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-md bg-primary flex items-center justify-center">
            <Fish className="w-4 h-4 text-primary-foreground" />
          </div>
          <span className="font-display font-extrabold">Florida Sportsman</span>
        </div>
        <p className="mt-3 text-xs text-muted-foreground leading-relaxed">
          Community & marketplace for Florida's hunters, anglers and boaters.
        </p>
        <p className="mt-3 text-xs font-semibold" style={{ color: "hsl(218 62% 24%)" }} data-testid="footer-2a-statement">
          Proud supporters of the 2nd Amendment & the NRA.
        </p>
      </div>
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground mb-3">Explore</div>
        <ul className="space-y-2 text-sm">
          <li><Link to="/forum" className="hover:text-primary" data-testid="footer-forum">Forum</Link></li>
          <li><Link to="/marketplace" className="hover:text-primary" data-testid="footer-marketplace">Marketplace</Link></li>
        </ul>
      </div>
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground mb-3">Community</div>
        <ul className="space-y-2 text-sm">
          <li><Link to="/rules" className="hover:text-primary" data-testid="footer-rules">Community rules</Link></li>
        </ul>
      </div>
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground mb-3">Legal</div>
        <ul className="space-y-2 text-sm">
          <li><Link to="/terms" className="hover:text-primary" data-testid="footer-terms">Terms of Service</Link></li>
          <li><Link to="/privacy" className="hover:text-primary" data-testid="footer-privacy">Privacy Policy</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 text-xs text-muted-foreground flex flex-wrap gap-4 justify-between">
        <span>© {new Date().getFullYear()} Florida Sportsman Community</span>
        <span>Built by anglers, for anglers.</span>
      </div>
    </div>
  </footer>
);
